import { render, staticRenderFns } from "./travelOverviewEn.vue?vue&type=template&id=77eb0458&scoped=true&lang=html&"
import script from "./travelOverviewEn.vue?vue&type=script&lang=js&"
export * from "./travelOverviewEn.vue?vue&type=script&lang=js&"
import style0 from "./travelOverviewEn.vue?vue&type=style&index=0&id=77eb0458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eb0458",
  null
  
)

export default component.exports